var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"administrative-tasks"},[_c('div',{staticClass:"title"},[_c('app-title',[_vm._v("Tareas administrativas")])],1),_vm._v(" "),_c('div',{staticClass:"content"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }